import { render, staticRenderFns } from "./UserHeaderMenu.vue?vue&type=template&id=8179f8e8&scoped=true&"
import script from "./UserHeaderMenu.vue?vue&type=script&lang=js&"
export * from "./UserHeaderMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserHeaderMenu.vue?vue&type=style&index=0&id=8179f8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8179f8e8",
  null
  
)

export default component.exports